import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
/*
 * @Author: jianfanfan 1217572833@qq.com
 * @Date: 2022-12-03 13:56:48
 * @LastEditors: jianfanfan 1217572833@qq.com
 * @LastEditTime: 2025-04-15 09:51:51
 * @FilePath: \pc-chitengmall\src\tools\regexp.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
var regphone = /^1(3|4|5|6|7|8|9)\d{9}$/; // 验证手机号码
var regpassword = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/; // 验证注册登录密码
var taxnumber = /^[A-Z0-9]{16}$|^[A-Z0-9]{18}$/; // 验证纳税人识别号16、19位
var banknumber = /^([1-9]{1})(\d{15,18})$/; // 验证银行卡号
var bankname = /^[\u4e00-\u9fa5](银行)$/; // 验证开户行(只能为中文已银行结尾);
var regemail = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,10})$/; // 验证邮箱
export var isValidPhone = function isValidPhone(phone) {
  return regphone.test(phone);
};
export var isValidPassword = function isValidPassword(password) {
  return regphone.test(password);
};
export var isValidTax = function isValidTax(number) {
  return taxnumber.test(number);
};
export var isValidBank = function isValidBank(number) {
  return banknumber.test(number);
};
export var isValidBankName = function isValidBankName(name) {
  return bankname.test(name);
};
// 验证密码8到20位字母加数字
export var validatePassWord = function validatePassWord(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入密码'));
  } else if (!regpassword.test(value)) {
    callback(new Error('请输入正确的6到20位密码'));
  } else {
    callback();
  }
};
// 验证手机号码
export var validateTelPhone = function validateTelPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入电话号码'));
  } else if (!regphone.test(value)) {
    callback(new Error('请输入正确的11位手机号码'));
  } else {
    callback();
  }
};
// 验证纳税人识别号
export var validateTaxNumber = function validateTaxNumber(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入纳税人识别号'));
  } else if (!taxnumber.test(value)) {
    callback(new Error('请填写正确的纳税人识别号(16或者18位)'));
  } else {
    callback();
  }
};
// 验证银行卡号
export var validateBankNumber = function validateBankNumber(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入银行卡号'));
  } else if (!banknumber.test(value)) {
    callback(new Error('请填写正确的银行账号(16-19位)'));
  } else {
    callback();
  }
};
// 验证银行名称
export var validateBankName = function validateBankName(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入开户行'));
  } else if (!bankname.test(value)) {
    callback(new Error('请填写正确的开户行'));
  } else {
    callback();
  }
};
// 验证邮箱
export var validateEmail = function validateEmail(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入邮箱'));
  } else if (!regemail.test(value)) {
    callback(new Error('请输入正确的邮箱'));
  } else {
    callback();
  }
};